export enum OpportunityStatusEnum {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}
